import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import { Navigation, FreeMode } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="tecnologias"]');

class Tecnologias {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            this.initSwipers(component);
            this.initTabs(component);
            this.initModals(component);
        });
    }

    initSwipers(component) {
        component.querySelectorAll('.swiper').forEach((swiperEl) => {
            const prevEl = swiperEl.querySelector('.swiper-button-prev-circle');
            const nextEl = swiperEl.querySelector('.swiper-button-next-circle');

            const getSwiperOffset = () => {
                return Math.max(0, window.innerWidth / 2 - 640);
            };

            swiperEl._swiper = new Swiper(swiperEl, {
                modules: [Navigation, FreeMode],

                slidesPerView: 'auto',
                spaceBetween: 0,

                slidesOffsetBefore: getSwiperOffset(),
                slidesOffsetAfter: 20,

                navigation: {
                    prevEl,
                    nextEl,
                    enabled: true,
                },

                freeMode: {
                    enabled: false,
                },

                breakpoints: {
                    0: {
                        navigation: {
                            enabled: false,
                        },
                        freeMode: {
                            enabled: true,
                        },
                    },

                    768: {
                        navigation: {
                            enabled: true,
                        },
                        freeMode: {
                            enabled: false,
                        },
                    },
                },

                watchOverflow: true,
            });

            const updateSwiperOffset = () => {
                swiperEl._swiper.params.slidesOffsetBefore = getSwiperOffset();
                swiperEl._swiper.update();
            };

            window.addEventListener('resize', updateSwiperOffset);
        });
    }


    initTabs(component) {
        const tabs = component.querySelectorAll('.tab-item');
        const panels = component.querySelectorAll('.tab-panel');
        if (tabs.length < 2) return;

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const target = tab.dataset.tabTarget;

                tabs.forEach((item) => {
                    const active = item === tab;
                    item.classList.toggle('is-active', active);
                    item.setAttribute('aria-selected', active ? 'true' : 'false');
                });

                panels.forEach((panel) => {
                    if (panel.dataset.tabPanel === target) {
                        panel.classList.remove('hidden');
                        requestAnimationFrame(() => {
                            panel.classList.remove('opacity-0');
                            panel.classList.add('opacity-100');
                        });
                        panel.querySelectorAll('.swiper').forEach((swiperEl) => {
                            if (swiperEl._swiper) {
                                swiperEl._swiper.update();
                            }
                        });
                    } else {
                        panel.classList.add('opacity-0');
                        panel.classList.remove('opacity-100');
                        const hide = () => {
                            panel.classList.add('hidden');
                            panel.removeEventListener('transitionend', hide);
                        };
                        panel.addEventListener('transitionend', hide);
                    }
                });
            });
        });
    }

    initModals(component) {
        const triggers = component.querySelectorAll('[data-modal-target]');
        const modals = component.querySelectorAll('[data-modal]');

        const closeModal = (modal) => {
            const panel = modal.querySelector('.tec-modal-panel');
            const overlay = modal.querySelector('.tec-modal-overlay');
            panel.classList.add('opacity-0');
            overlay.classList.add('opacity-0');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('block-scroll');

            const hide = () => {
                modal.classList.add('hidden');
                modal.classList.remove('flex');
                panel.removeEventListener('transitionend', hide);
            };
            panel.addEventListener('transitionend', hide);
        };

        const openModal = (modal) => {
            const panel = modal.querySelector('.tec-modal-panel');
            const overlay = modal.querySelector('.tec-modal-overlay');
            modal.classList.remove('hidden');
            modal.classList.add('flex');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('block-scroll');

            requestAnimationFrame(() => {
                panel.classList.remove('opacity-0');
                overlay.classList.remove('opacity-0');
            });
        };

        triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const modal = component.querySelector(`[data-modal="${trigger.dataset.modalTarget}"]`);
                if (modal) openModal(modal);
            });
        });

        modals.forEach((modal) => {
            modal.querySelectorAll('[data-modal-close]').forEach((el) => {
                el.addEventListener('click', () => closeModal(modal));
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape') return;
            modals.forEach((modal) => {
                if (!modal.classList.contains('hidden')) closeModal(modal);
            });
        });
    }
}

(() => {
    if (MODULE.length) {
        new Tecnologias();
    }
})();

export default Tecnologias;
